module.exports = require("webpack-notifier");